/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/

// Helpers
import { getEndpoint } from '@lib/helpers'
import config from '@/config'
import axios from 'axios'

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * create a new sale type
 */
export const createSaleType = async (data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sale-types'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * update a sale type
 */
export const updateSaleType = async (sale_type_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sale-types/'+sale_type_id),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * create a new sale type label and associate to this sale type
 */
export const addLabelToSaleType = async (sale_type_id = null, data = null) => {
    return new Promise(( resolve, reject ) => {

        if (!sale_type_id) return reject({ message: 'The sale type id is required'})

        if (!data) return reject({ message: 'The label data is required'})

        axios({
            method: 'post',
            url: getEndpoint('/sale-types/'+sale_type_id+'/label'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the sale types for an auctioneer
 */
export const getAuctioneerSaleTypes = async auctioneer_id => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) return reject({ message: 'The auctioneer_id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sale-types'),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the sale sections for an auctioneer
 */
export const getAuctioneerSaleSections = async auctioneer_id => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) return reject({ message: 'The auctioneer id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sale-sections'),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the sale sections for an auctioneer
 */
export const getAuctioneerSaleCodes = async auctioneer_id => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) return reject({ message: 'The auctioneer id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sale-codes'),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * create a new sale section
 */
export const createSaleSection = async (data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sale-sections'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * update a new sale section
 */
export const updateSaleSection = async (sale_section_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sale-sections/'+sale_section_id),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * create a new sale code
 */
export const createSaleCode = async (data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sale-codes'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * attach sale types to a sale section
 */
export const attachSaleTypesToSaleSection = async (sale_section_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sale-sections/'+sale_section_id+'/sale-types'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * sync sale types to a sale section
 */
export const syncSaleTypesToSaleSection = async (sale_section_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sale-sections/'+sale_section_id+'/sale-types'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * attach sale codes to a sale section
 */
export const attachSaleCodesToSaleSection = async (sale_section_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sale-sections/'+sale_section_id+'/sale-codes'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * sync sale codes to a sale section
 */
export const syncSaleCodesToSaleSection = async (sale_section_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sale-sections/'+sale_section_id+'/sale-codes'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * attach sale sections to a sale type
 */
export const attachSaleSectionsToSaleType = async (sale_type_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sale-types/'+sale_type_id+'/sale-sections'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * sync sale sections to a sale type
 */
export const syncSaleSectionsToSaleType = async (sale_type_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sale-types/'+sale_type_id+'/sale-sections'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * attach sale sections to a sale code
 */
export const attachSaleSectionsToSaleCode = async (sale_code_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sale-codes/'+sale_code_id+'/sale-sections'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * sync sale sections to a sale code
 */
export const syncSaleSectionsToSaleCode = async (sale_code_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sale-codes/'+sale_code_id+'/sale-sections'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * attach feature field to a sale code
 */
export const attachFeatureFieldToSaleCode = async (sale_code_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sale-codes/'+sale_code_id+'/feature-field'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

// 

/**
 * get the sale types for an user
 */
export const getUserSaleTypes = async (user_id, params = []) => {
    return new Promise(( resolve, reject ) => {

        if (!user_id) return reject({ message: 'The user id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/user/'+user_id+'/sale-types', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the sale sections for an user
 */
export const getUserSaleSections = async (user_id, params = []) => {
    return new Promise(( resolve, reject ) => {

        if (!user_id) return reject({ message: 'The user id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/user/'+user_id+'/sale-sections', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the sale codes for an user
 */
export const getUserSaleCodes = async (user_id, params = []) => {
    return new Promise(( resolve, reject ) => {

        if (!user_id) return reject({ message: 'The user id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/user/'+user_id+'/sale-codes', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the feature fields for a single user
 */
export const getUserFeatureFields = async (user_id, params = []) => {
    return new Promise(( resolve, reject ) => {

        if (!user_id) return reject({ message: 'The user id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/user/'+user_id+'/sale-feature-fields', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get a sale type by id
 */
export const getSaleTypeById = async sale_type_id => {
    return new Promise(( resolve, reject ) => {

        if (!sale_type_id) return reject({ message: 'The sale type id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/sale-types/'+sale_type_id),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get a sale section by id
 */
export const getSaleSectionById = async sale_section_id => {
    return new Promise(( resolve, reject ) => {

        if (!sale_section_id) return reject({ message: 'The sale section id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/sale-sections/'+sale_section_id),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get a sale code by id
 */
export const getSaleCodeById = async sale_code_id => {
    return new Promise(( resolve, reject ) => {

        if (!sale_code_id) return reject({ message: 'The sale code id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/sale-codes/'+sale_code_id),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get a sale code by id
 */
export const updateSaleCode = async (sale_code_id, data) => {
    return new Promise(( resolve, reject ) => {

        if (!sale_code_id) return reject({ message: 'The sale code id is required'})

        axios({
            method: 'patch',
            url: getEndpoint('/sale-codes/'+sale_code_id),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the sale codes for an othanisation
 */
export const getOrganisationSaleCodes = async organisation_id => {
    return new Promise(( resolve, reject ) => {

        if (!organisation_id) return reject({ message: 'The organisation id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/organisation/'+organisation_id+'/sale-codes'),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * create a draft sale
 */
export const createDraftSale = async data => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sales/create-draft'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

// retrieve-draft

/**
 * get a draft sale that's in the process of being configured
 */
export const getDraftSale = async sale_id => {
    return new Promise(( resolve, reject ) => {

        if (!sale_id) return reject({ message: 'The sale id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/sales/'+sale_id+'/retrieve-draft'),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * set the times on a draft sale
 */
export const setDraftSaleTimes = async (sale_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sales/'+sale_id+'/set-times'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * update a sale
 */
export const updateSale = async (sale_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sales/'+sale_id),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * associate a sale code to an asset
 */
export const assignSaleCode = async (auctioneer_id, asset_id, data) => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) return reject({ message: 'The auctioneer_id is required'})

        if (!asset_id) return reject({ message: 'The asset_id is required'})

        if (!data?.sale_code_id) return reject({ message: 'The sale_code_id is required'})

        axios({
            method: 'post',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/asset/'+asset_id+'/sale-code'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * activate a sale
 */
export const activate = async sale_id => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sales/'+sale_id+'/activate'),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get this user's sales
 */
export const getForUser = async (user_id, params = []) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'get',
            url: getEndpoint('/user/'+user_id+'/sales', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * delete a collection of sales
 */
export const batchDelete = async data => {
    return new Promise(( resolve, reject ) => {

        if (!data.sale_ids) return reject({ message: 'The sale_ids are required'})

        axios({
            method: 'delete',
            url: getEndpoint('/sales/batch'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * update a collection of sales
 */
export const batchUpdate = async data => {
    return new Promise(( resolve, reject ) => {

        if (!data.sale_ids) return reject({ message: 'The sale_ids are required'})

        axios({
            method: 'patch',
            url: getEndpoint('/sales/batch'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * create a feature field for an associated sale related object
 */
export const createField = async data => {
    return new Promise(( resolve, reject ) => {

        if (!data.model_type) return reject({ message: 'The model_type is required'})
        if (!data.model_ids) return reject({ message: 'The model_ids is required'})
        if (!data.label) return reject({ message: 'The label is required'})
        if (!data.type) return reject({ message: 'The type is required'})
        if (!data.auctioneer_id) return reject({ message: 'The auctioneer_id is required'})

        axios({
            method: 'post',
            url: getEndpoint('/feature-fields'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get a feature field
 */
export const getFeatureField = async feature_field_id => {
    return new Promise(( resolve, reject ) => {

        if (!feature_field_id) return reject({ message: 'The feature_field_id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/feature-fields/'+feature_field_id),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * update a feature field
 */
export const updateFeatureField = async (feature_field_id, data) => {
    return new Promise(( resolve, reject ) => {

        if (!feature_field_id) return reject({ message: 'The feature_field_id is required'})
        if (!data.model_type) return reject({ message: 'The model_type is required'})
        if (!data.model_ids) return reject({ message: 'The model_ids is required'})
        if (!data.label) return reject({ message: 'The label is required'})
        if (!data.type) return reject({ message: 'The type is required'})
        if (!data.auctioneer_id) return reject({ message: 'The auctioneer_id is required'})

        axios({
            method: 'patch',
            url: getEndpoint('/feature-fields/'+feature_field_id),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the availability of lot numbers for a given auctioneer
 */
export const lotNumberAvailable = async (params = []) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'get',
            url: getEndpoint('/lot-number/available', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the eligible assets for this sale
 */
export const getEligibleAssets = async (params = []) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/asset/eligible-for-sale', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the eligible sales for this asset
 */
export const getEligibleSales = async (params = []) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/sales/eligible-for-asset', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

// auctioneer/{auctioneer}/sales/{sale}/lot'

/**
 * add an asset to an auctioneer's sale 
 */
export const addLotToAuctioneerSale = async (auctioneer_id, sale_id, data) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'post',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sales/'+sale_id+'/lot'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * withdraw a lot from a sale
 */
export const withdrawLotFromSale = async (auctioneer_id, sale_id, lot_id) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'patch',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sales/'+sale_id+'/lot/'+lot_id+'/withdraw'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * withdraw a lot from a sale
 */
export const markLotAsUnsold = async (auctioneer_id, sale_id, lot_id) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'patch',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sales/'+sale_id+'/lot/'+lot_id+'/unsold'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get lots
 */
export const getLots = async (params = []) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/lot', params),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get sale by id
 */
export const getById = async sale_id => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/sales/'+sale_id),
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * publish a sale
 */
export const publish = async sale_id => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sales/'+sale_id+'/publish-status'),
            data: {
                'publish_status': 'published'
            },
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * unpublish a sale
 */
export const unpublish = async sale_id => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'patch',
            url: getEndpoint('/sales/'+sale_id+'/publish-status'),
            data: {
                'publish_status': 'unpublished'
            },
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * sale export
 */
export const exportBidJS = async sale_id => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/sales/'+sale_id+'/export-bidjs'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const exportWebSaleReport = async sale_id => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/sales/'+sale_id+'/export-web-sale-report'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const exportInfomart = async sale_id => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/sales/'+sale_id+'/export-infomart'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * export sale as json
 * @param sale_id
 * @returns {Promise<unknown>}
 */
export const exportSaleJson = async sale_id => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/sales/'+sale_id+'/export-sale-json'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const exportUserSaleSettings = async (user_id, params) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/user/'+user_id+'/sale-settings', params),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * delete an auctioneer's sale type
 */
export const deleteAuctioneerSaleType = async (auctioneer_id, sale_type_id) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'delete',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sale-types/'+sale_type_id),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * delete an auctioneer's sale section
 */
export const deleteAuctioneerSaleSection = async (auctioneer_id, sale_section_id) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'delete',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sale-sections/'+sale_section_id),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * delete an auctioneer's sale code
 */
export const deleteAuctioneerSaleCode = async (auctioneer_id, sale_code_id) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'delete',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sale-codes/'+sale_code_id),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const withdrawManyLots = async (sale_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sales/'+sale_id+'/withdraw-lots'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const markManyAsUnsold = async (sale_id, data) => {
    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/sales/'+sale_id+'/mark-many-as-unsold'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}